import { Link } from "react-router";
import * as styles from "./Error.module.css";

export default function Error() {
  return (
    <div className={styles.container}>
      <title>404 Error</title>
      <h2 className={styles.heading}>Oops... Page not found!</h2>
      <p>
        Checkout the{" "}
        <Link className={styles.link} to="/">
          homepage
        </Link>
      </p>
    </div>
  );
}
